<div class="compra-segura-partial">
      <img src="images/icons/cadeado.svg" alt="Compra segura" width="15px" height="15px" />
      <span>Este ambiente é 100% seguro. Seus dados pessoais e seus dados de pagamento estarão protegidos e criptografados.</span>
  </div>    